import { hot } from "react-hot-loader";

import React from "react";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import { number, oneOfType, string } from "prop-types";

import * as S from "./styled";

const EditListingLink = ({ editListingUrl, listingId }) => (
  <ButtonAction
    data-analytics-name="editListingGA"
    data-analytics-params={`{"listing_id": ${listingId}}`}
    data-analytics-type="click"
    element={actionElements.a}
    href={editListingUrl}
    rel="nofollow"
    theme={buttonActionThemes.TERTIARY}
  >
    <S.PenIcon />
    Edit Listing
  </ButtonAction>
);

EditListingLink.propTypes = {
  listingId: oneOfType([string, number]).isRequired,
  editListingUrl: string.isRequired
};

export default hot(module)(EditListingLink);
